import template from './ko-field-input-number-range.html';

class NumberRangeInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.$input = params.$input;
	}
}


export default {
	name: 'ko-field-input-number-range',
	viewModel: NumberRangeInputComponentVM,
	module_type: 'ko',
	template: template
};
